module.exports = "https://web-assets-production.autolist.com/_next/static/images/coupe-c2537fbd4c1454fac39677efa7963162.jpg";